import { difficultyToColourClass, ratingToDifficulty } from './utils';
import type { FixtureCellData } from './constants';

type FixtureCellProps = {
  fixture: FixtureCellData;
};

const MODERATE_DIFFICULTY = 5;
const FULL_LIKELIHOOD = 1;

export const FixtureCell = ({ fixture }: FixtureCellProps) => {
  const venueLabel = fixture.venue === 'home' ? '(H)' : '(A)';
  const difficulty =
    fixture.inferences?.difficulty.overall ?? MODERATE_DIFFICULTY;
  const toPlay = fixture.inferences?.probabilities.toPlay ?? FULL_LIKELIHOOD;
  const colourClass = difficultyToColourClass(ratingToDifficulty(difficulty));
  const isDoubtful = toPlay !== FULL_LIKELIHOOD;

  return (
    <div
      className={`relative flex h-full w-full items-center justify-center rounded-md px-1 py-1.5 text-xs text-neutral-800 ${colourClass}`}
    >
      {isDoubtful && (
        <div className="bg-diagonal-stripes pointer-events-none absolute inset-0 rounded-md opacity-50" />
      )}
      <span className="relative whitespace-nowrap">
        {fixture.opponent.shortName} {venueLabel}
      </span>
    </div>
  );
};
